var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostboxRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50.856,
    r: 50.856,
    fill: "#FCDCDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.728 52.867h-2.064V87.74a.895.895 0 0 0 .132.486c.092.154.229.294.402.412.174.117.38.21.608.271.227.062.47.092.716.088h.206v-36.13Z",
    fill: "#7F5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.728 52.867h2.065V87.74a.902.902 0 0 1-.137.49 1.342 1.342 0 0 1-.411.415 2.103 2.103 0 0 1-.62.27c-.23.06-.477.088-.725.082h-.172v-36.13Z",
    fill: "#684800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.501 23.366h25.562a11.41 11.41 0 0 1 11.41 11.41v16.596a2.232 2.232 0 0 1-2.233 2.232H29.337a2.232 2.232 0 0 1-2.232-2.232V34.776a11.41 11.41 0 0 1 11.409-11.41H38.5Z",
    fill: "#F2605E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.175 24.981A10.599 10.599 0 0 1 49.774 35.58v14.726a1.677 1.677 0 0 1-1.678 1.677h-17.83a1.677 1.677 0 0 1-1.677-1.677V35.567A10.599 10.599 0 0 1 39.187 24.97l-.012.012Z",
    fill: "#D84644"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.71 49.395c0 1.87-.386 2.494-1.763 2.494L39 51.964l-9.177-.044c-1.384 0-1.733-2.556-.624-3.223l3.878-1.172 16.634-4.364",
    fill: "#A83735"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.145 15.73h-.623v25.56h.623V15.73Z",
    fill: "#FEB400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.769 15.73h-.624v25.56h.623V15.73Z",
    fill: "#F2A803"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.239 43.161a2.089 2.089 0 1 0 0-4.177 2.089 2.089 0 0 0 0 4.177Z",
    fill: "#EFEFEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.239 42.22a1.147 1.147 0 1 0 0-2.294 1.147 1.147 0 0 0 0 2.294Z",
    fill: "#C9C9C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m63.29 20.436-7.768.742v-5.436a1.054 1.054 0 0 1 1.247-1.054l6.602 1.247a1.165 1.165 0 0 1 .879 1.247v2.057a1.16 1.16 0 0 1-.96 1.197Z",
    fill: "#F2A803"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.503 51.983H49.91v1.62H12.503a.623.623 0 0 1-.623-.623v-.392a.624.624 0 0 1 .623-.624v.019Z",
    fill: "#F2605E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m45.085 47.663-21.328 2.974a1.247 1.247 0 0 1-1.447-.998l-1.982-12.295a1.203 1.203 0 0 1 1.072-1.352l21.322-2.974a1.247 1.247 0 0 1 1.453.997L46.17 46.31a1.247 1.247 0 0 1-1.085 1.353Z",
    fill: "#F4F4F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.383 40.169c-2.8 1.827-6.771 7.562-9.558 9.389Z",
    fill: "#E5E5E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.383 40.169c-2.8 1.827-6.771 7.562-9.558 9.389",
    stroke: "#DBDBDB",
    strokeWidth: 0.422,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.583 40.318c3.248.985 8.005 5.318 11.222 6.31Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.583 40.318c3.248.985 8.005 5.318 11.222 6.31",
    stroke: "#DBDBDB",
    strokeWidth: 0.422,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.121 44.726a1.303 1.303 0 0 0 1.746-.243l8.978-11.29a1.142 1.142 0 0 0-.86-.225L21.318 35.99a1.067 1.067 0 0 0-.555.237l12.357 8.498Z",
    fill: "#DDD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostboxRound);
export default __webpack_public_path__ + "static/media/postbox-round.d6a180784127b8b0da3c27f01bc4a54b.svg";
export { ForwardRef as ReactComponent };